import { AppVersionContext } from "AppVersionContext";
import { useContext } from "react";

export const useAppVersionContext = () => {
  const appVersionContext = useContext(AppVersionContext);

  if (!appVersionContext) {
    throw new Error(
      "useAppVersionContext must be used within an AppVersionProvider",
    );
  }

  return appVersionContext;
};
